import { render, staticRenderFns } from "./clioImport.vue?vue&type=template&id=f5d6bc28"
import script from "./clioImport.vue?vue&type=script&lang=js"
export * from "./clioImport.vue?vue&type=script&lang=js"
import style0 from "./clioImport.vue?vue&type=style&index=0&id=f5d6bc28&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports